import { authorizedFetch } from '@/helpers/authFetch';
import checkedFetch, { checkedTextFetch } from '@/utils/fetchers';
import { campaignRequestEndpoint } from './serviceConstants';

const MISSING_LANGUAGES_ERROR = 'missing_campaign_languages';
const MISSING_LANGUAGES_REST_ERROR_CODE = 409;

const getAvailableLanguages = () => checkedFetch(`${campaignRequestEndpoint}/languages`, { languages: [] });

const addVariantLanguages = (campaignId, languages = []) => {
  const url = `${campaignRequestEndpoint}/campaigns/${campaignId}/languages?codes=${languages.join('%2C')}`;
  const headers = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return checkedTextFetch(url, null, headers);
};

const checkAllLanguages = async (id) => {
  const response = await authorizedFetch(`${campaignRequestEndpoint}/campaigns/${id}/validate-languages`, { method: 'PUT' });

  if (response.ok) {
    return [];
  }

  const responseJson = await response.json();
  const hasErrorStatus = response.status === MISSING_LANGUAGES_REST_ERROR_CODE;
  const hasMissingLanguagesError = responseJson.errorCode === MISSING_LANGUAGES_ERROR;
  const hasMissingLanguages = hasErrorStatus && hasMissingLanguagesError;

  if (hasMissingLanguages) {
    return responseJson.errorMessage ? responseJson.errorMessage.split(',') : [];
  }

  throw new Error(response.statusText);
};

export default {
  getAvailableLanguages,
  addVariantLanguages,
  checkAllLanguages,
};
